/*
 * Module for the landlord details modal
 */

define([
  "marionette",
  "messaging/messenger",
  "./landlordModalView",
  "modules/accountAdmin/landlordAdmin/landlordModel",
], function (Marionette, Messenger, LandlordModalView, LandlordModel) {
  var LandlordModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "landlordModal";
      this.editMode = options.editMode;
    },
    show: function (landlord) {
      this.landlord = landlord;
      this.landlord.editMode = this.editMode;
      this.layout = new LandlordModalView.landlordModalLayout({
        model: this.landlord,
      });

      this.landlord.backup();

      landlord.on(
        "invalid",
        function (model, error) {
          this.layout.clearErrors();
          if (error["landlordName"]) {
            this.layout.nameError(error["landlordName"]);
          }
          if (error["tenantCapacity"]) {
            this.layout.tenantCapacityError(error["tenantCapacity"]);
          }
          if (error["kbCapacity"]) {
            this.layout.kbCapacityError(error["kbCapacity"]);
          }
          if (error["responseTypeCapacity"]) {
            this.layout.responseTypeCapacityError(error["responseTypeCapacity"]);
          }
          if (error["taskManagement"]) {
            this.layout.taskManagementError(error["taskManagement"]);
          }
          if (error["actionGroups"]) {
            this.layout.actionGroupsError(error["actionGroups"]);
          }
          if (error["agentAssist"]) {
            this.layout.agentAssistError(error["agentAssist"]);
          }
          if (error["adHocReporting"]) {
            this.layout.adHocReportingError(error["adHocReporting"]);
          }
          if (error["recommendations"]) {
            this.layout.recommendationsError(error["recommendations"]);
          }
          if (error["crossTouchPointAccess"]) {
            this.layout.crossTouchPointAccessError(error["crossTouchPointAccess"]);
          }
          if (error["siteMapAccess"]) {
            this.layout.siteMapAccessError(error["siteMapAccess"]);
          }
        },
        this,
      );

      this.layout.on(
        "done",
        function () {
          //save model
          landlord.set("landlordName", this.layout.getLandlordName());
          if (landlord.isNew()) {
            landlord.set("tenantCapacity", { capacity: this.layout.getTenantCapacity(), usage: 0 });
            landlord.set("kbCapacity", {
              capacity: this.layout.getKnowledgebaseCapacity(),
              usage: 0,
            });
            landlord.set("responseTypeCapacity", {
              capacity: this.layout.getResponseTypeCapacity(),
              usage: 0,
            });
          } else {
            landlord.set("tenantCapacity", {
              capacity: this.layout.getTenantCapacity(),
              usage: landlord.get("tenantCapacity").usage,
            });
            landlord.set("kbCapacity", {
              capacity: this.layout.getKnowledgebaseCapacity(),
              usage: landlord.get("kbCapacity").usage,
            });
            landlord.set("responseTypeCapacity", {
              capacity: this.layout.getResponseTypeCapacity(),
              usage: landlord.get("responseTypeCapacity").usage,
            });
          }
          landlord.set("taskManagement", {
            enabled: this.layout.getTaskManagement(),
            inUse: landlord.get("taskManagement").inUse,
          });
          landlord.set("actionGroups", {
            enabled: this.layout.getActionGroups(),
            inUse: landlord.get("actionGroups").inUse,
          });
          landlord.set("agentAssist", {
            enabled: this.layout.getAgentAssist(),
            inUse: landlord.get("agentAssist").inUse,
          });
          landlord.set("adHocReporting", {
            enabled: this.layout.getAdHocReporting(),
            inUse: landlord.get("adHocReporting").inUse,
          });
          landlord.set("recommendations", {
            enabled: this.layout.getRecommendations(),
            inUse: landlord.get("recommendations").inUse,
          });
          landlord.set("crossTouchPointAccess", {
            enabled: this.layout.getCrossTouchPointAccess(),
            inUse: landlord.get("crossTouchPointAccess").inUse,
          });
          landlord.set("siteMapAccess", {
            enabled: this.layout.getSiteMapAccess(),
            inUse: landlord.get("siteMapAccess").inUse,
          });

          // By default, BackBone.js does not validate models that have not been changed (not dirty)
          // This is normally what we want, but in this case we want to ensure that we catch invalid
          // inUse/enabled combinations that may come from the server before attempting to save.
          // i.e. if enabled is false for a landlord, but is inUse by nested knowledge base.
          if (!landlord.isValid()) {
            return;
          }

          if (Messenger.reqres.request("save:textbox")) {
            landlord.saveModel({
              success: function (landlord) {
                landlord.dirty = false;
                Messenger.vent.trigger("close:modal");
              },
            });
          }
        },
        this,
      );

      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
          //if item is new, delete it
          if (landlord.isNew()) {
            landlord.deleteModel();
          } else {
            landlord.restore();
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.layout);
    },
  });

  return LandlordModalController;
});
